<template>
  <div id="app">
    <!--if no login-->
    <login v-if="!getIsLogin"></login>
    <section v-if="getIsLogin">
      <div class="main-menu" id="mainMenu">
        <b-nav vertical pills>
          <b-nav-item class="mb-2">
            <div>
              {{ getSecondName }}
            </div>
            <div>
              {{ getName }}
            </div>
            <div class="mt-2 mb-2">
              <b-button class="btn-sm" v-on:click="LOGOUT()">Выйти</b-button>
            </div>
          </b-nav-item>
          <b-nav-item
              v-for="item in getSection"
              v-bind:key="item.name"
              :to="{name: item.name}"
              :active="isActive(item.name, $router.currentRoute.name)"
          >
            {{ item.alias }}
          </b-nav-item>

        </b-nav>
      </div>
      <div class="main-content">
        <div class="alert-box mb-2">
          <a v-if="isNewAlert" href="#/alert/messages"><i class="alert-link-content"></i></a>
        </div>
        <router-view></router-view>
      </div>
      <b-modal id="errorResponse" hide-footer title="Ошибка">
        <p class="">Извините, произошла ошибка :(</p>
        <p class="error-content" v-html="getErrorText"></p>
        <p>{{ getErrorTime }}</p>
        <b-button class="mt-3" variant="outline-error"  scrollable @click="$bvModal.hide('errorResponse')">Ок</b-button>
      </b-modal>
      <b-modal id="infoMessage" class="info-message" hide-footer title="Сообщение">
        <p class="my-2">{{ getInfoText }}</p>
        <b-button class="mt-3" variant="outline-success" block @click="$bvModal.hide('infoMessage')">Ок</b-button>
      </b-modal>
    </section>
  </div>
</template>

<script>
import login from "@/components/login/login";
import {mapGetters, mapActions} from 'vuex';
import {config} from "@/config";

export default {
  name: "layout",
  data() {
    return {
      isNewAlert: false,
      referenceSectionToPage: {
        settings: ['settings', 'googleAccount'],
        user: ['user', 'roles', 'control'],
        brand: ['brand', 'brandInfo', 'brandSemantics', 'brandProducts', 'brandCountry', 'brandDynamics', 'brandContent', 'brandError'],
        product: ['product', 'goodsCategory', 'goodsImport', 'goodsImportList', 'goodsAdd', 'goodsExport', 'goodsDelete', 'GoodsMassChange', 'CategoriesExport', 'CategoryMatching'],
        translations: ['translations', 'translationTasks', 'dictionary'],
        analytics: ['analytics', 'salesAnalyticsCountryBrand'],
        sites: ['sites', 'sitePositions', 'groupPosition', 'siteStatistic'],
        alert: ['alert', 'alertConfig'],
        order: ['order'],
        suppliers: [
            'suppliers', 'suppliersTaskList', 'suppliersArchiveList', 'suppliersKeys', 'suppliersStopWords',
          'suppliersExcludedSites', 'suppliersViewTask'
        ],
        competitors: [
            'competitors', 'competitorsTaskList', 'competitorsArchiveList', 'competitorsViewTask'
        ],
        ai: [
          'test'
        ]
      }
    }
  },
  components: {
    login
  },
  methods: {
    ...mapActions(['LOGOUT', 'sendAlertCheck', 'getSectionList']),
    cleanError: function () {
      this.$store.commit('setErrorText', '');
    },
    alertChecker: function () {
      if (!(this.$store.getters.getAllowSection.indexOf('alert') === -1)) {
        this.sendAlertCheck({th: this, frequency: config.alertFrequency})
      }
    },
    isActive: function (sectionName, pageName) {
      return this.referenceSectionToPage[sectionName].includes(pageName)
    }
  },
  computed: {
    ...mapGetters([
      'getIsLogin',
      'getName',
      'getSecondName',
      'getErrorText',
      'getInfoText',
      'getAllowSection',
      'getErrorTime',
      'SECTIONS',
    ]),
    getSection: function () {
      return this.SECTIONS.filter(i => this.getAllowSection.includes(i.name))
    }
  },
  mounted() {
    this.$store.commit('setBvModal', this.$bvModal);
    this.alertChecker()
    this.getSectionList({th: this})
  },
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
  padding: 0 25px;
  width: 1903px;
}

.main-menu {
  float: left;
  height: 100%;
  width: 7%;
  text-align: left;
}

.main-menu li {
  /*border: solid 2px #dee2e6;*/
  /*border-bottom: 0;*/
  margin-right: 10px;
  display: table;
  height: auto;
  min-height: 56px;
}

.main-menu li:last-child {
  /*border: solid 2px #dee2e6;*/
}

.main-menu li a {
  display: table-cell;
  vertical-align: middle;
}

.main-content {
  float: right;
  width: 92%;
  padding-top: 20px;
}

.page-name {
  text-align: left;
}

.error-content {
  font-size: 0.9rem;
}

.alert-box {
  text-align: right;
  height: 40px;
  margin-top: -34px;
  position: absolute;
  width: 90.3%;
}

.alert-link-content {
  display: inline-block;
  height: 40px;
  width: 40px;
  background-image: url("../../assets/images/alert.jpg");
  background-position: right center;
  background-size: 110px;
  margin-right: -10px;
}
</style>

<style>
.info-message.modal, #infoMessage.modal {
  width: 14%;
  height: 57%;
  top: -1em;
  left: 102.5em;
}
#infoMessage.modal-header {
  padding: 0.5rem 0.5rem;
}
.modal-backdrop {
  display: none;
  opacity: 0;
}
</style>